const navigationWidget = () => {
    const $htmlBody = $('html, body');
    const navigation = document.querySelector('.navigation');
    const navigationAnchors = navigation.querySelectorAll('.links-modal a[href^="#"], .website-pages a[href^="#"]');
    const navigationAnchorsArr = [...navigationAnchors];
    const anchoredSections = document.querySelectorAll('#home, #expertise, #career, #contact');
    const scrolltopButton = navigation.querySelector('.scrolltop');
    const loginSubmit = navigation.querySelector('.login-modal button.cta');
    const loginErr = navigation.querySelector('.login-modal .err');
    const modals = document.querySelectorAll('.modal[data-modal]');
    const fontSwitcher = navigation.querySelector('.font-switcher');
    const aosElements = document.querySelectorAll('[data-aos]');
    const printButton = navigation.querySelector('.print-switcher');

    const print = () => {
        [...aosElements].forEach(aosElement =>
            aosElement.classList.add('aos-animate')
        );

        setTimeout(() => {
            window.print();
        }, 1000);
    };

    const switchFontSize = (e) => {
        e.preventDefault();
        e.stopPropagation();
        $htmlBody.toggleClass('big-font');
    };

    const closeAllModals = () => {
        [...modals].forEach(modal =>
            modal.classList.remove('shown'));
    };

    const scrollToTop = () => $htmlBody.animate({ scrollTop: 0 });

    const showLoginErr = () => loginErr.classList.add('shown');

    const getElementOffsetTop = element => {
        let top = 0;
        let el = element;
        while (el.offsetParent) {
            top += el.offsetTop;
            el = el.offsetParent;
        }
        return top;
    };

    const applyNavigationScrollState = () => {
        const top = window.pageYOffset || document.documentElement.scrollTop;
        if (top > 0) {
            navigation.classList.add('fixed');
            scrolltopButton.classList.add('shown');
        } else {
            navigation.classList.remove('fixed');
            scrolltopButton.classList.remove('shown');
        }
        [].forEach.call(anchoredSections, (section) => {
            const sectionOffset = getElementOffsetTop(section);
            const sectionOffsetBottom = section.offsetHeight + sectionOffset;
            const sectionId = '#' + section.getAttribute('id');
            const relatedAnchor = navigationAnchorsArr.find(anchor => anchor.getAttribute('href') === sectionId);
            if (top <= sectionOffsetBottom - 100 && top >= sectionOffset - 100) {
                relatedAnchor.classList.add('active');
            } else {
                relatedAnchor.classList.remove('active');
            }
        });
    };

    const scrollToTarget = (event) => {
        event.preventDefault();
        const anchor = event.target;
        const targetId = anchor.getAttribute('href');
        const target = document.querySelector(targetId);
        const currentLocation = window.location.href;
        const newLocation = currentLocation.substring(0, currentLocation.indexOf('#')) + targetId;
        closeAllModals();
        history.replaceState({}, document.title, newLocation);
        if (target) $htmlBody.animate({ scrollTop: getElementOffsetTop(target) });
    };

    printButton.addEventListener('click', print);
    fontSwitcher.addEventListener('click', switchFontSize);
    document.addEventListener('scroll', applyNavigationScrollState);
    loginSubmit.addEventListener('click', showLoginErr);
    scrolltopButton.addEventListener('click', scrollToTop);
    navigationAnchorsArr.forEach(anchor => anchor.addEventListener('click', scrollToTarget));
};

navigationWidget();
